<template>
    <div>
      <div class="vx-row">
        <div class="vx-col w-full mt-5">
          <ul class="heading-ul mb-5">
              <li>
                <router-link
                  :to="{ path: '/setup/property-definition' }"
                  class="vx-row"
                >
                  <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                  <h4>{{ $t("setup.label.ViewPropertyMaster") }}</h4>
                </router-link>
              </li>
            </ul>
        </div>
        <div class="vx-col w-full">
          <vx-card title no-shadow card-border>
            <div class="vx-row">
              <div class="vx-col w-full md:w-full lg:w-full">
                <ul class="horizontal-sm-btn flex mb-2 float-right">
                  <li>
                    <div
                      class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                    >
                      <vs-button
                        color="primary"
                        icon-pack="feather"
                        icon="icon-edit-2"
                        class="truncate"
                        @click="editData()"
                        size="small"
                        >{{ $t("setup.label.Edit") }}</vs-button
                      >
                      <vs-button
                        color="danger"
                        icon-pack="feather"
                        icon="icon-x"
                        class="truncate"
                        size="small"
                        @click="deletePropertyMasterPopup = true"
                        >{{ $t("setup.label.Delete") }}</vs-button
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="block overflow-x-auto">
              <table class="table w-full table-bordered table-striped">
                <tr>
                  <td>
                    <b>{{ $t("setup.label.Code") }}</b>
                  </td>
                  <td>{{ propertyMasterViewData.code }}</td>
                </tr>
                <tr>
                  <td>
                    <b>{{ $t("setup.label.Description") }}</b>
                  </td>
                  <td>{{ propertyMasterViewData.description }}</td>
                </tr>
                <tr>
                  <td>
                    <b>{{ $t("setup.label.PropertyCodeType") }}</b>
                  </td>
                  <td>{{ propertyMasterViewData.propertyCodeType }}</td>
                </tr>
                <tr>
                  <td>
                    <b>{{ $t("setup.label.ReferenceValue") }}</b>
                  </td>
                  <td>{{ propertyMasterViewData.referenceValue }}</td>
                </tr>
              </table>
            </div>
          </vx-card>
        </div>
      </div>
      <delete-popup
        :deletePopup="deletePropertyMasterPopup"
        :title="$t('setup.label.PropertyMaster')"
        @deletePressed="deletePropertyMaster()"
        @cancelPressed="deletePropertyMasterPopup = false"
      >
      </delete-popup>
    </div>
  </template>
  <script>
  import { mapState } from "vuex";
  export default {
    data() {
      return {
        deletePropertyMasterPopup: false,
      };
    },
  
    computed: {
      ...mapState({
        propertyMasterViewData: (state) => state.propertyDefinition.propertyMasterView,
      }),
    },
    methods: {
      async getPropertyMasterViewData() {
        try {
          await this.$store.dispatch(
            "propertyDefinition/viewPropertyMasterAction",
            this.id
          );
        } catch (error) {
          throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
        }
        console.log(this.propertyMasterViewData,"data")
      },
      async deletePropertyMaster() {
        try {
          this.deletePropertyMasterPopup = false;
          await this.$store.dispatch(
            "propertyDefinition/deletePropertyMasterAction",
            this.id
          );
          this.$router.push({ path: `/setup/property-definition` });
        } catch (error) {
          throw Error(
            error.message.errors[0].defaultUserMessage ||
              `Api failed with status code: ${error.message.httpStatusCode}`
          );
        }
      },
      editData() {
        this.$router.push({
          path: `/setup/property-definition/EditPropertyMaster/${this.id}`,
        });
      },
    },
    filters: {},
    created() {
      this.id = this.$route.params.id;
      this.getPropertyMasterViewData();
    },
  };
  </script>
  <style scoped>
  .table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
    background-color: #fff;
    border: solid 1px #f0f0f0;
  }
  
  .table td {
    vertical-align: middle;
    border-top: none;
    padding: 10px 7px;
    font-size: 14px;
    color: #646a71;
    border-bottom: 1px solid #dfe3e7;
    transition: all 0.2s ease;
    overflow: hidden;
    word-break: break-all;
  }
  </style>
  